<template>
  <span>
    <v-card class="elevation-10">
      <infraction-notices-header
        :infraction_notices="infractionNotices"
        :amount="cards"
        :activeStatus="status"
        @activeStatusChanged="changeActiveStatus"
      />
    </v-card>

    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="teal darken-4"
    />

    <infraction-notices-list
      :infraction_notices="infractionNotices"
      :totalPages="total_pages"
      :totalItems="cards.total"
      @changePage="changePage"
    />
  </span>
</template>

<script>
import InfractionNoticesService from '@/services/applications/InfractionNoticesService';
import InfractionNoticesList from '@/components/tabs/list/InfractionNoticesList';
import InfractionNoticesHeader from '@/components/tabs/header/InfractionNoticesHeader';

export default {
  name: 'InfractionNotices',
  props: ['isAdmin'],
  components: {
    InfractionNoticesList,
    InfractionNoticesHeader,
  },
  data() {
    return {
      status: '',
      page: 1,
      infractionNotices: [],
      cards: { total:0 },
      total_filtered: 0,
      total_pages: 0,
      isLoading: false,
    };
  },
  mounted() {
    this.fetchInfractionNotices();
  },
  methods: {
    changeActiveStatus(status) {
      this.status = status;
      this.fetchInfractionNotices();
    },
    fetchInfractionNotices() {
      this.isLoading = true;
      if (this.isAdmin) {
        this.fetchAdminInfractionNotices();
      } else {
        this.fetchUserInfractionNotices();
      }
    },
    fetchUserInfractionNotices() {
      InfractionNoticesService
        .fetchInfractionNotices({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.infractionNotices = data.infraction_notices;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.new);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchAdminInfractionNotices() {
      InfractionNoticesService
        .adminFetchInfractionNotices({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.infractionNotices = data.infraction_notices;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.waiting_to_be_sent);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchInfractionNotices();
    }
  }
}
</script>
